<template>
  <div class="bodycontent">
    <div class="page_title">
      安全设置
    </div>
    <div class="page_form">
      <el-form ref="form" :model="form" :rules="rules" label-width="200px">
        <div class="phone-code">
          <el-form-item label="接收验证码手机号" prop="mobile">
            <el-input
              v-model="form.mobile"
              placeholder="请输入接收验证码手机号码"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="余额调整验证码">
          <el-radio-group v-model="form.open_sms_balance">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分调整验证码">
          <el-radio-group v-model="form.open_sms_point">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠券推送验证码">
          <el-radio-group v-model="form.open_sms_coupon">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="删除订单验证码">
          <el-radio-group v-model="form.open_sms_delete_order">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="现金充值验证码">
          <el-radio-group v-model="form.open_cash_order">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="油品退款验证码">
          <el-radio-group v-model="form.open_refund_order">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值退款验证码">
          <el-radio-group v-model="form.open_refund_recharge">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="普通订单退款验证码">
          <el-radio-group v-model="form.open_refund_normal">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="交班删除验证码">
          <el-radio-group v-model="form.open_delete_duty">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员删除验证码">
          <el-radio-group v-model="form.open_delete_user">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="平台卡退款验证码">
          <el-radio-group v-model="form.open_refund_platform_order">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户端支付密码">
          <el-radio-group
            v-model="form.open_client_user_paypass"
            @change="show_dialog($event, 1)"
          >
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="管理端支付密码">
          <el-radio-group
            v-model="form.open_manage_user_paypass"
            @change="show_dialog($event, 2)"
          >
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员调整级别">
          <el-radio-group v-model="form.open_update_level">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queren">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- ，短信验证弹窗 -->
    <el-dialog
      :visible.sync="verificationStatus"
      title="短信验证"
      width="500px"
      :before-close="handleNote"
    >
      <el-form ref="form" label-width="100px">
        <div>
          <el-form-item label="校验码">
            <el-input placeholder="请输入内容" v-model="imageCode">
              <template slot="append">
                <img :src="imageBase64" alt="" style="width: 100px;height: 20px;" @click="getImageData"/>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input class="input_box" v-model="verification_code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(0)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">
          确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import verificationCode from "@/utils/verificationCode";

import { mapGetters } from "vuex";
import { get_safeinfo, set_safe } from "@/api/set";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let str = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (!str.test(value)) {
        callback(new Error("请输入正确手机号码"));
      }
    };
    return {
      tempForm: {},
      imageCode: "",
      imageBase64: "",
      uuid: "",
      form: {
        mobile: "",
        open_sms_point: "",
        open_sms_balance: "",
        open_sms_coupon: "",
        open_sms_delete_order: "",
        open_cash_order: "",
        open_refund_order: "",
        open_refund_recharge: "",
        open_refund_normal: "",
        open_delete_duty: "",
        open_client_user_paypass: "",
        open_manage_user_paypass: "",
        open_refund_platform_order: "",
        open_delete_user: "",
        open_update_level: "",
      },
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      verification_code: "",
      verificationStatus: false,
      rules: {
        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
      },
    };
  },
  created() {
    this.get_detail();
  },
  methods: {
    async getImageData(){
      const data = await verificationCode.getImage();
      if(data){
        console.log("验证图片", data);
      this.imageBase64 = data.img;
      this.uuid = data.uuid;
    }
  },
    queren() {
      this.getImageData()
      this.verificationStatus = true;
      
    },
    show_dialog(val, i) {
      console.log("eeee", val);
      if (val == 0) {
        this.$confirm(
          "关闭后用户资保障率将会下降，不建议关闭，请谨慎操作，出现问题由油站方自行负责！",
          "提示",
          {
            type: "warning",
            center: true,
          }
        )
          .then(() => {})
          .catch(() => {
            if (i == 1) {
              this.form.open_client_user_paypass = "1";
            }
            if (i == 2) {
              this.form.open_manage_user_paypass = "1";
            }
          });
      }
    },
    // 关闭
    handleNote() {
      this.$confirm("确认关闭？")
        .then((_) => {
          // done();
          this.btn_status = false;
          clearInterval(this.timer);
          this.timer = null;
          this.code_text = "获取验证码";
          this.verificationStatus = false;
          this.verification_code = "";
        })
        .catch((_) => {});
    },
    getCode() {
      const TIME_COUNT = 60;
      const arrObj = {};
      if (!this.time) {
        this.count = TIME_COUNT;
        // 向管理员发送验证码
        
        var data = { app_id: this.app_id };
        get_safeinfo(data).then((res) => {
          for (let i in res.data) {
            res.data[i] = res.data[i].toString();
            if (this.form[i] != res.data[i]) {
              arrObj[i] = this.form[i];
            }
            console.log(i, this.form[i], res.data[i]);
          }
          console.log(arrObj);

          verificationCode.SendMyCode({...arrObj,code:this.imageCode,uuid:this.uuid});
          this.time = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              this.code_text = this.count + "s";
              this.btn_status = true;
            } else {
              this.btn_status = false;
              this.time = null;
              this.code_text = "获取验证码";
            }
          }, 1000);
        });
      }
    },
    async onSubmit(obj) {
      try {
        var data = {
          app_id: this.app_id,
          verification_code: this.verification_code,
          ...this.form,
        };
        const res = await set_safe(data);
        this.$message.success(res.msg);
        this.btn_status = false;
        this.timer = null;
        this.code_text = "获取验证码";
        this.verificationStatus = false;
        this.verification_code = "";
      } catch (error) {
        console.log(error);
      }
    },
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          let data = res.data;
          for (let i in res.data) {
            res.data[i] = res.data[i].toString();
          }
          this.form = res.data;
          this.tempForm = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    margin-top: 20px;
    .phone-code {
      max-width: 500px;
      height: 80px;
      display: flex;
      align-items: center;
      > .el-form-item {
        margin-bottom: 0;
      }
      > .el-button {
        margin-left: 20px;
      }
    }
  }
}
</style>
